import { produce } from 'immer';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import {
  CANCEL_RMA,
  CANCEL_RMA_FULFILLED,
  CANCEL_RMA_REJECTED,
  CLEAR_ACCOUNT_RMA,
  CLEAR_RMA_CANCEL,
  CLEAR_RMA_CREATE,
  CLEAR_RMA_INVOICES,
  CLEAR_RMA_SEND_EMAIL,
  CLEAR_RMA_UPDATE,
  CREATE_RMA,
  CREATE_RMA_FULFILLED,
  CREATE_RMA_REJECTED,
  FETCH_RMA,
  FETCH_RMA_FULFILLED,
  FETCH_RMA_INVOICE,
  FETCH_RMA_INVOICE_FULFILLED,
  FETCH_RMA_INVOICE_REJECTED,
  FETCH_RMA_REJECTED,
  SEND_RMA_EMAIL,
  SEND_RMA_EMAIL_FULFILLED,
  SEND_RMA_EMAIL_REJECTED,
  UPDATE_RMA,
  UPDATE_RMA_FULFILLED,
  UPDATE_RMA_REJECTED,
} from './actionTypes';
import { RmaAction, RmaState } from './types';

const initialState: RmaState = {
  cancel: RemoteRecordData.getDefault(),
  create: RemoteRecordData.getDefault(),
  rmaInvoices: {},
  rmas: {},
  send: RemoteRecordData.getDefault(),
  update: RemoteRecordData.getDefault(),
};

const reducer = (
  state: RmaState = initialState,
  action: RmaAction,
): RmaState => {
  switch (action.type) {
    case CREATE_RMA:
      return produce(state, (draft: RmaState) => {
        draft.create = RemoteRecordData.init();
      });

    case CREATE_RMA_FULFILLED:
      return produce(state, (draft: RmaState) => {
        draft.create = RemoteRecordData.fulfill({});
      });

    case CREATE_RMA_REJECTED:
      return produce(state, (draft: RmaState) => {
        draft.create = RemoteRecordData.reject(action.payload.error);
      });

    case FETCH_RMA:
      return produce(state, (draft: RmaState) => {
        draft.rmas[action.payload.rmaId] = RemoteRecordData.init();
      });

    case FETCH_RMA_FULFILLED:
      return produce(state, (draft: RmaState) => {
        draft.rmas[action.payload.rmaId] = RemoteRecordData.fulfill(
          action.payload.data,
        );
      });

    case FETCH_RMA_REJECTED:
      return produce(state, (draft: RmaState) => {
        draft.rmas[action.payload.rmaId] = RemoteRecordData.reject(
          action.payload.error,
        );
      });

    case FETCH_RMA_INVOICE:
      return produce(state, (draft: RmaState) => {
        draft.rmaInvoices[
          action.payload.rmaInvoiceId
        ] = RemoteRecordData.init();
      });

    case FETCH_RMA_INVOICE_FULFILLED:
      return produce(state, (draft: RmaState) => {
        draft.rmaInvoices[
          action.payload.rmaInvoiceId
        ] = RemoteRecordData.fulfill(action.payload.data);
      });

    case FETCH_RMA_INVOICE_REJECTED:
      return produce(state, (draft: RmaState) => {
        draft.rmaInvoices[
          action.payload.rmaInvoiceId
        ] = RemoteRecordData.reject(action.payload.error);
      });

    case CANCEL_RMA:
      return produce(state, (draft: RmaState) => {
        draft.cancel = RemoteRecordData.init();
      });

    case CANCEL_RMA_FULFILLED:
      return produce(state, (draft: RmaState) => {
        draft.cancel = RemoteRecordData.fulfill({});
      });

    case CANCEL_RMA_REJECTED:
      return produce(state, (draft: RmaState) => {
        draft.cancel = RemoteRecordData.reject(action.payload.error);
      });

    case UPDATE_RMA:
      return produce(state, (draft: RmaState) => {
        draft.update = RemoteRecordData.init();
      });

    case UPDATE_RMA_FULFILLED:
      return produce(state, (draft: RmaState) => {
        draft.update = RemoteRecordData.fulfill({});
      });

    case UPDATE_RMA_REJECTED:
      return produce(state, (draft: RmaState) => {
        draft.update = RemoteRecordData.reject(action.payload.error);
      });

    case SEND_RMA_EMAIL:
      return produce(state, (draft: RmaState) => {
        draft.send = RemoteRecordData.init();
      });

    case SEND_RMA_EMAIL_FULFILLED:
      return produce(state, (draft: RmaState) => {
        draft.send = RemoteRecordData.fulfill({});
      });

    case SEND_RMA_EMAIL_REJECTED:
      return produce(state, (draft: RmaState) => {
        draft.send = RemoteRecordData.reject(action.payload.error);
      });

    case CLEAR_ACCOUNT_RMA:
      return initialState;

    case CLEAR_RMA_CANCEL:
      return produce(state, (draft: RmaState) => {
        draft.cancel = initialState.cancel;
      });

    case CLEAR_RMA_CREATE:
      return produce(state, (draft: RmaState) => {
        draft.create = initialState.create;
      });

    case CLEAR_RMA_INVOICES:
      return produce(state, (draft: RmaState) => {
        draft.rmaInvoices = initialState.rmaInvoices;
      });

    case CLEAR_RMA_SEND_EMAIL:
      return produce(state, (draft: RmaState) => {
        draft.send = initialState.send;
      });

    case CLEAR_RMA_UPDATE:
      return produce(state, (draft: RmaState) => {
        draft.update = initialState.update;
      });

    default:
      return state;
  }
};

export { reducer };
